import { useCallback } from 'react';

import { useQuery } from '@tanstack/react-query';

import { getPartyById, type GetPartyByIdResponse } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import { applyDemoPartyOverrides } from '@/lib/party/demoPartyOverrides';
import useCurrentBroker from '@/queries/hooks/useCurrentBroker';
import type { QueryOptions } from '@/types/react-query';

import queryKeys from '../queryKeys';

export default function useParty(
  id: string,
  options?: QueryOptions<GetPartyByIdResponse>,
) {
  const { data: broker } = useCurrentBroker();
  const optionsSelect = options?.select;

  const select = useCallback(
    (party: GetPartyByIdResponse) => {
      const overridden = applyDemoPartyOverrides(party, broker?.email);

      return optionsSelect ? optionsSelect(overridden) : overridden;
    },
    [broker?.email, optionsSelect],
  );

  return useQuery({
    queryKey: queryKeys.byId(id),
    queryFn: () => getPartyById({ path: { party_id: id } }, wgApi),
    ...options,
    select,
  });
}
